import { Autocomplete, Box, FormControl, Grid, IconButton, MenuItem, Popper, Select, Stack, Switch, TextField, Tooltip, Typography } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {useState, useMemo} from "react";
import _ from 'lodash';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import momenttz from "moment-timezone";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import customPlanIcon from "../../asset/image/CustomPlanBlue.svg";
import orgPoolIcon from "../../asset/image/CustomPoolBlue.svg";
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment-timezone';
import DayPicker from "../CommonComponents/DayPicker";

const TemplateInfo = ({ planPoolToggle, handlePlanPoolToggle, currentSubPool, handleSubPoolChange, isEditMode, selectedMonthYear, setSelectedMonthYear, day, setDay }) => {
    
    
    const handleDayPicker = (value) => {
        handleDateSelection(value, selectedMonthYear);
    }

    const daysInMonth = selectedMonthYear.daysInMonth();
    let days = Array.from({ length: 28 }, (_, i) => ({ label: (i + 1).toString(), value: i + 1 }));
    if (daysInMonth > 28) {
        days.push({ label: "Last Day", value: daysInMonth });
    }

    const handleDateSelection = (date, monthYear) => {
        const formattedMonthYear = monthYear.format("YYYY-MM");
        setDay({ label: date === selectedMonthYear.daysInMonth() ? "Last Day" : date.toString(), value: date });
        setSelectedMonthYear(monthYear);
        const startDate = moment(`${formattedMonthYear}-${date}`, "YYYY-MM-DD").format("YYYY-MM-DD");
        handleSubPoolChange('startDate', startDate);
    }

    const changeDuration = (value) => {
        handleSubPoolChange("duration", value);
        handleDateSelection(1, moment());
    }
    
    return (
        <>
            <Stack className="starlink-new-plans-container">
                <Box className="starlink-new-plans-item">
                    <Typography className="starlink-new-plans-label">Type</Typography>
                    <Box className="starlink-new-plans-type-select-wrapper">
                        <FormControl fullWidth size="small">
                            <Select  disabled={isEditMode} value={planPoolToggle} onChange={(e) => handlePlanPoolToggle(e.target.value)}>
                                <MenuItem value="Pool">Pool</MenuItem>
                                <MenuItem value="Plan">Plan</MenuItem>
                            </Select>
                        </FormControl>
                        <IconButton className="starlink-new-plans-type-icon" size="small">
                            <img className="starlink-create-plan-icon icon-cursor" src={planPoolToggle === "Plan" ? orgPoolIcon : customPlanIcon} />
                        </IconButton>
                    </Box>
                </Box>

                <Box className="starlink-new-plans-item">
                    <Typography className="starlink-new-plans-label">Name</Typography>
                    <TextField
                        fullWidth
                        size="small"
                        value={currentSubPool?.poolName}
                        onChange={(e) => handleSubPoolChange("poolName", e.target.value)}
                        placeholder={`Enter a Name of ${planPoolToggle}`}
                    />
                </Box>

                <Box className="starlink-new-plans-item">
                    <Typography className="starlink-new-plans-label">Description</Typography>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Enter a Description"
                        value={currentSubPool?.poolInfo}
                        onChange={(e) => handleSubPoolChange("poolInfo", e.target.value)}
                    />
                </Box>

                <Box className="starlink-new-plans-row">
                    <Box className="starlink-new-plans-item small plan-item-width" style={{maxWidth: "80px"}}>
                        <Typography className="starlink-new-plans-label">Size</Typography>
                        <TextField
                            fullWidth
                            size="small"
                            type="number"
                            value={currentSubPool.poolSize}
                            disabled={isEditMode}
                            onChange={(e) => handleSubPoolChange("poolSize", e.target.value)}
                            placeholder="0"
                            inputProps={{ min: 1 }}
                        />
                    </Box>

                    <Box className="starlink-new-plans-item small plan-item-width" style={{maxWidth: "65px"}}>
                        <Typography className="starlink-new-plans-label invisible-label">Unit</Typography>
                        <FormControl fullWidth size="small">
                            <Select
                                disabled={isEditMode}
                                value={currentSubPool.unit}
                                onChange={(e) => handleSubPoolChange("unit", e.target.value)}
                            >
                                <MenuItem value="gb">GB</MenuItem>
                                <MenuItem value="tb">TB</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box className="starlink-new-plans-item medium plan-item-width" style={{maxWidth: "105px"}}>
                        <Typography className="starlink-new-plans-label">Duration</Typography>
                        <FormControl fullWidth size="small">
                            <Select
                                disabled={isEditMode}
                                value={currentSubPool.duration}
                                onChange={(e) => changeDuration(e.target.value)}
                            >
                                <MenuItem value="monthly">Monthly</MenuItem>
                                <MenuItem value="yearly">Yearly</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>


                    <Box
                        className="starlink-new-plans-item medium plan-item-width"
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-start"
                        style={{maxWidth: "70px"}}
                    >
                        <Typography className="starlink-new-plans-label">Recurring</Typography>
                        <Box height="40px" display="flex" alignItems="center">
                            <label className="if-switch-toggle" style={{ marginTop: '2px' }}>
                                <input
                                    type="checkbox"
                                    checked={currentSubPool.isRecurring}
                                    onChange={(e) => handleSubPoolChange("isRecurring", e.target.checked)}
                                />
                                <span className="if-slider-toggle" />
                            </label>
                        </Box>
                    </Box>

                    <Box className="starlink-new-plans-item medium plan-item-width">
                        <Typography className="starlink-new-plans-label">Start Date</Typography>
                        <div style={{display:"flex", alignItems: "center", gap:"10px"}}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                views={["year", "month"]}
                                value={selectedMonthYear}
                                format="MM/YYYY"
                                onChange={(newValue) => handleDateSelection(1, newValue)}
                                slots={{ textField: TextField }}
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                        InputProps: {
                                            readOnly: true,
                                            style: { height: "40px" }
                                        }
                                    }
                                }}
                                disabled={isEditMode || currentSubPool.duration!="yearly"}
                                // readOnly
                                // disableOpenPicker
                            />
                        </LocalizationProvider>
                        <Grid item xs={4}>
                            <DayPicker
                                width={118}
                                height={40}
                                dayOptions={days}
                                handleDayPicker={handleDayPicker}
                                day={day}
                                dayDisplayKey={"label"}
                                isDisabled={isEditMode}
                                disableClear={true}
                                daysInMonth={daysInMonth}
                            />    
                        </Grid>
                        </div>
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

const mapStateToProps = (state) => ({
});

export default withRouter(
    connect(mapStateToProps, {})(TemplateInfo)
)